import {InlineLink, Text} from '@primer/react-brand/esm'

import {linkClickAnalytics} from '../../utils/analytics'
import {CloseButton} from '../CloseButton/CloseButton'
import styles from './Universe26Banner.module.css'
import type {BannerDescriptor} from '../../marketing-global-banner.types'
import universe26Logo from './assets/universe_26-logo.svg'
import {Universe26BannerVisual} from './Universe26BannerVisual'

export function Universe26Banner({banner}: {banner: BannerDescriptor}) {
  const {uid, title, link, link_label} = banner
  const clickAnalytics = linkClickAnalytics(uid, title)

  return (
    <div className={styles.banner}>
      <a data-analytics-event={clickAnalytics} href={link} className={styles.logolink}>
        <img src={universe26Logo} width={145} height={16} alt="" />
        <span className={styles.visuallyHidden}>GitHub Universe 2026</span>
      </a>

      <hr className={styles.divider} />

      <div className={styles.info}>
        {title ? (
          <Text as="span" size="100" weight="semibold" className={styles.title}>
            {title}
          </Text>
        ) : null}

        <hr className={styles.divider} />

        <InlineLink data-analytics-event={clickAnalytics} href={link} className={styles.link}>
          {link_label}
        </InlineLink>
      </div>

      <Universe26BannerVisual />

      <CloseButton uid={uid} wrapperClassName={styles.closeWrapper} buttonClassName={styles.closeButton} />
    </div>
  )
}
